/*
Sohel 04/13/2023 2698964415 Added Type Field in Filter Criteria
Sohel 04/13/2023 2698964415 Added Field Type Issue
Akhila 04/28//2023 2698964415 modified in field type and sql output
Sohel 05/10/2023 2698811066 Fixed Type Payload Issue
Akhila 06/02/2023 2698811066 changed field type date between and not between
Sohel 10/05/2023 2698811066 Filter Criteria  Added Table Column Name and Field Name Changes
Sohel 10/13/2023 2698811066 Filter Condition Changes
*/
import {IconButton, Tooltip} from '@material-ui/core';
import React, {useRef} from 'react';
import GuiAutoComplete from '../FormComponents/GuiAutoComplete';
import GuiTextField from '../FormComponents/GuiTextField';
import reusableInputStyles from '../InputStyles';
import {withField} from './withField';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import {ErrorMessage} from './ErrorMessage';
import {getIn} from 'formik';
import {GetFields, getOptions, generateSql} from './FilterRulesUtils';
export const typeOptions = [
  {label: 'Field', value: 'file'},
  {label: 'Value', value: 'value'},
];
const FilterRules = (props) => {
  const {
    name,
    value: current,
    setFieldValue,
    fields = [],
    handleDelete,
    errors,
    touched,
    handleBlur,
    mapFieldsData,
    isFilterRules = false,
  } = props;
  const classes = reusableInputStyles();
  // const [valueField, setValueField] = useState('');
  const valueField = '';
  const userEnteredValRef = useRef('');
  const handleChange = (property, value) => {
    const copy = {...current};
    copy[property] = value;
    if (property === 'field') {
      copy['condition'] = '';
      copy['value'] = '';
      copy['value1'] = '';
      copy['sqlValue'] = '';
    }
    if (property === 'condition' || property === 'type') {
      if (current.field.fieldType.toLowerCase() === 'date') {
        copy['value'] = '';
        copy['valu1'] = '';
        copy['valueField'] = valueField;
        copy['value1'] = '';
      } else {
        copy['value'] = '';
        copy['valu1'] = '';
        copy['value1'] = '';
      }
    }
    if (property === 'condition') {
      copy['type'] = {label: 'Value', value: 'value'};
    }
    generateSql(copy, userEnteredValRef, isFilterRules);
    setFieldValue(name, copy);
  };
  // React.useEffect(() => {
  //   let copy1 = { ...current };
  //   if (current?.field?.fieldType?.toLowerCase() === "date") {
  //     copy1["valueField"] = valueField;
  //   } else {
  //     copy1["value"] = "";
  //     copy1["valu1"] = "";
  //   }
  //   generateSql(copy1);
  // }, [generateSql, valueField]);

  React.useEffect(() => {
    name && setFieldValue && setFieldValue(name, current);
  }, [name, current, setFieldValue]);

  const getError = (name) => getIn(touched, name) && getIn(errors, name);
  const showSqlOutput =
    (current?.condition &&
      (current?.condition?.value === 'isBlank' || current?.condition?.value === 'isNotBlank')) ||
    (current?.condition && current?.sqlValue && (current?.value || current?.value1));
  const hideValuesConditions = [
    'Is',
    'Is not',
    'Less than',
    'Greater than',
    'Less than equal',
    'Greater than equal',
  ];
  return (
    <div>
      <div className="sql-builder-section global-field-textfields mt-3">
        <div className="rulecode-section">
          <span>{current?.ruleCode}</span>
        </div>
        <div className="col-md-4 col-lg-3 form-group sqlAutocomplete-input">
          <GuiAutoComplete
            classes={{
              popper: classes.popper,
              option: classes.option,
            }}
            id="field"
            value={current?.field ? current?.field : ''}
            options={fields ? fields : []}
            size="small"
            autoHighlight
            name={`${name}.field`}
            getOptionLabel={(option) => {
              return option && option?.fieldName ?
                `${option?.repository} - ${option?.fieldName}` :
                '';
            }}
            renderInput={(params) => (
              <GuiTextField
                {...params}
                InputLabelProps={{
                  shrink: true,
                }}
                fullWidth
                onBlur={handleBlur}
                margin="dense"
                label="Field"
                error={getError(`${name}.field`)}
                name={`${name}.field`}
                placeholder="Select field"
                inputProps={{
                  ...params.inputProps,
                  autoComplete: 'off',
                }}
              />
            )}
            onChange={(_, data) => {
              handleChange('field', data);
            }}
          />
          <ErrorMessage
            render={(msg) => (
              <div className={msg ? `error-text rule-bulider-error` : ``}>{msg}</div>
            )}
            name={`sqlRules[${props.index}].field`}
          />
        </div>

        {current?.field && (
          <>
            <div className="col-md-4 col-lg-2 form-group sqlAutocomplete-input">
              <GuiAutoComplete
                classes={{
                  popper: classes.popper,
                  option: classes.option,
                }}
                id="category"
                value={current?.condition}
                name={`${name}.condition`}
                options={getOptions(current?.field?.fieldType?.toLowerCase())}
                size="small"
                autoHighlight
                getOptionLabel={(option) => {
                  return option && option?.value ? option.label : '';
                }}
                renderInput={(params) => (
                  <GuiTextField
                    {...params}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    onBlur={handleBlur}
                    fullWidth
                    margin="dense"
                    label="Condition"
                    name="condition"
                    error={getError(`${name}.condition`)}
                    placeholder="Select Condition"
                    inputProps={{
                      ...params.inputProps,
                      autoComplete: 'off',
                    }}
                  />
                )}
                onChange={(_, data) => {
                  handleChange('condition', data);
                }}
              />
              <ErrorMessage
                render={(msg) => <div className="error-text rule-bulider-error">{msg}</div>}
                name={`sqlRules[${props.index}].condition`}
              />
            </div>
            {hideValuesConditions?.includes(current?.condition?.label) ? (
              <div className="type-field form-group">
                <GuiAutoComplete
                  classes={{
                    popper: classes.popper,
                    option: classes.option,
                  }}
                  id="type"
                  value={current.type || {}}
                  name={`${name}.type`}
                  options={typeOptions}
                  size="small"
                  autoHighlight
                  getOptionLabel={(option) => {
                    return option && option?.value ? option.label : '';
                  }}
                  renderInput={(params) => (
                    <GuiTextField
                      {...params}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      onBlur={handleBlur}
                      fullWidth
                      margin="dense"
                      label="Type"
                      name="type"
                      error={getError(`${name}.type`)}
                      placeholder="Select Type"
                      inputProps={{
                        ...params.inputProps,
                        autoComplete: 'off',
                      }}
                    />
                  )}
                  onChange={(_, data) => {
                    handleChange('value', '');
                    handleChange('type', data || {});
                  }}
                />
                <ErrorMessage
                  render={(msg) => <div className="error-text rule-bulider-error">{msg}</div>}
                  name={`sqlRules[${props.index}].type`}
                />
              </div>
            ) : null}
          </>
        )}

        {current?.condition &&
        current?.condition?.value &&
        hideValuesConditions?.includes(current?.type?.value) &&
        current?.condition?.value !== 'BETWEEN' &&
        current?.condition?.value !== 'NOT BETWEEN' ? (
            <div
              className={`${
              current?.condition.value === 'isBlank' || current?.condition.value === 'isNotBlank' ?
                'col-lg-0' :
                ['BETWEEN', 'NOT BETWEEN'].includes(current?.condition.value) ?
                  'col-lg-4' :
                  'col-lg-2'
            } form-group`}
            >
              <GetFields
                type={current?.field?.fieldType?.toLowerCase()}
                fileType={current?.type?.value}
                rule={current}
                name={`${name}.value`}
                name1={`${name}.value1`}
                error={getError(`${name}.value`)}
                handleUpdateRule={handleChange}
                mapFieldsData={mapFieldsData}
                handleBlur={handleBlur}
                userEnteredValRef={userEnteredValRef}
              />
            </div>
          ) : (
            current?.condition && (
              <div
                className={`${
                current?.condition.value === 'isBlank' || current?.condition.value === 'isNotBlank' ?
                  'col-lg-0' :
                  ['BETWEEN', 'NOT BETWEEN'].includes(current?.condition.value) ?
                    'col-lg-4' :
                    'col-lg-2'
              } form-group`}
              >
                <GetFields
                  type={current?.field?.fieldType?.toLowerCase()}
                  fileType={current?.type?.value}
                  rule={current}
                  name={`${name}.value`}
                  name1={`${name}.value1`}
                  error={getError(`${name}.value`)}
                  handleUpdateRule={handleChange}
                  mapFieldsData={mapFieldsData}
                  userEnteredValRef={userEnteredValRef}
                />
              </div>
            )
          )}
        {showSqlOutput && (
          <div className="output-field form-group px-2">
            <div className="label-text  sql-output-label">SQL Output</div>
            <div className="sql-output-value" title={current?.sqlValue}>
              {current?.sqlValue}
            </div>
          </div>
        )}
        <div>
          <Tooltip title="Delete">
            <IconButton onClick={() => handleDelete(current)}>
              <DeleteOutlineIcon />
            </IconButton>
          </Tooltip>
        </div>
      </div>
    </div>
  );
};

export default withField(FilterRules);
